import { Button } from "react-bootstrap";
import PulseLoader from "react-spinners/PulseLoader";

const LoadingButton = ({ isLoading, children, loaderColor = "#fff", ...props }) => {
  return (
    <Button
      disabled={isLoading}
      {...props}
    >
      {isLoading ? (
        <PulseLoader
          color={loaderColor}
          loading={isLoading}
          // cssOverride={override}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      ):(
        children
      )}
    </Button>
  );
};

export default LoadingButton;